<form [formGroup]="form">
  <mat-form-field appearance="outline">
    @if (!hideLabel) {
    <mat-label>
      @if (!autoTranslate) {
      <span>{{labelName}}</span>
      } @else {
      <mwp-text-translate [text]="labelName" [jsonKey]="labelName" />
      }
    </mat-label>
    }
    <mat-select [formControlName]="nameForControl" (openedChange)="onOpened()">
      @for (item of list; track item) {
      <mat-option [value]="item.value" (onSelectionChange)="onChange($event)">
        {{item.text}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>